(() => {
  const root = document.getElementById('rv-catalog');
  if (!root || root.dataset.coloursReady) return;
  root.dataset.coloursReady = 'true';
  const normalise = value => String(value || '').trim().toLowerCase().replace(/grey/g, 'gray');
  const names = ['navy', 'black', 'gray', 'white'];
  const parameters = new URLSearchParams(location.search);
  const legacy = parameters.getAll('filter.v.option.farge');
  let selected = [...new Set([...parameters.getAll('rv_color'), ...legacy].map(normalise))].filter(value => names.includes(value));
  if (legacy.length) {
    const url = new URL(location.href);
    url.searchParams.delete('filter.v.option.farge');
    url.searchParams.delete('rv_color');
    selected.forEach(value => url.searchParams.append('rv_color', value));
    location.replace(url.href);
    return;
  }
  const singleColours = {
    'reviere-classic-knit': 'gray',
    'reviere-classic-knit-navy': 'navy',
    'reviere-classic-knit-black': 'black',
    'tennis-club-t-shirt': 'white',
    'golf-dazur-t-shirt-1': 'white',
    'reviere-striped-pants': 'navy',
    'white-striped-pants': 'white',
    'azur-striped-shorts': 'white',
    'monaco-striped-shorts': 'navy'
  };
  let products = {};
  let frame = 0;
  function productFor(card) {
    const id = card.dataset.productId || card.closest('[data-product-id]')?.dataset.productId;
    return products[id];
  }
  function colours(product) {
    const index = (product.options || []).findIndex(name => /colou?r|farge|farbe|couleur/i.test(typeof name === 'string' ? name : name.name));
    if (index >= 0) return [...new Set(product.variants.map(variant => normalise(variant.options[index])))];
    const handle = (product.url || '').split('?')[0].split('/').filter(Boolean).pop();
    return singleColours[handle] ? [singleColours[handle]] : [];
  }
  function writeUrl() {
    const url = new URL(location.href);
    url.searchParams.delete('rv_color');
    selected.forEach(value => url.searchParams.append('rv_color', value));
    history.replaceState(history.state, '', url.href);
  }
  function syncVariant(card, product) {
    const index = (product.options || []).findIndex(name => /colou?r|farge|farbe|couleur/i.test(typeof name === 'string' ? name : name.name));
    if (index < 0 || !selected.length) return;
    const matches = variant => selected.includes(normalise(variant.options[index]));
    const variant = product.variants.find(variant => variant.available && matches(variant)) || product.variants.find(matches);
    if (!variant) return;
    const colour = variant.options[index];
    card.dataset.rvActiveColor = colour;
    card.querySelectorAll('a[href*="/products/"]').forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('variant', variant.id);
      if (link.href !== url.href) link.href = url.href;
    });
    const input = [...card.querySelectorAll('product-swatches input[data-option-media-id]')].find(input => normalise(input.value) === normalise(colour));
    const scroller = card.querySelector('slideshow-slides');
    const slide = input && [...(scroller?.querySelectorAll('slideshow-slide') || [])].find(slide => slide.getAttribute('slide-id') === input.dataset.optionMediaId);
    if (slide && scroller) {
      const first = scroller.querySelector('slideshow-slide');
      scroller.scrollTo({ left: slide.offsetLeft - first.offsetLeft, behavior: 'instant' });
    }
    if (input) input.checked = true;
  }
  function apply() {
    try { products = JSON.parse(document.getElementById('rv-qa-products')?.textContent || '{}'); } catch { return; }
    const cards = [...document.querySelectorAll('#ResultsList product-card')];
    const totals = Object.fromEntries(names.map(name => [name, 0]));
    let count = 0;
    cards.forEach(card => {
      const product = productFor(card);
      if (!product) return;
      const values = colours(product);
      values.forEach(value => { if (value in totals) totals[value] += 1; });
      const visible = !selected.length || values.some(value => selected.includes(value));
      const item = card.closest('li[data-product-id]') || card;
      item.hidden = !visible;
      if (visible) { count += 1; syncVariant(card, product); }
    });
    document.querySelectorAll('button.rv-catalog__color[data-color]').forEach(button => {
      const colour = normalise(button.dataset.color);
      const active = selected.includes(colour);
      button.hidden = !totals[colour] && !active;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.querySelectorAll('input[name="rv_color"]').forEach(input => {
      const colour = normalise(input.value);
      input.checked = selected.includes(colour);
      const label = input.closest('label');
      if (label) {
        label.hidden = !totals[colour] && !input.checked;
        const text = label.querySelector('span');
        const display = colour === 'gray' ? 'Grey' : colour.charAt(0).toUpperCase() + colour.slice(1);
        if (text && text.textContent !== display + ' (' + totals[colour] + ')') text.textContent = display + ' (' + totals[colour] + ')';
      }
    });
    document.querySelectorAll('.rv-desk-count').forEach(label => {
      const text = count + ' ' + (count === 1 ? root.dataset.rvPiece : root.dataset.rvPieces);
      if (label.textContent.trim() !== text) label.textContent = text;
    });
    const grid = document.querySelector('#ResultsList');
    if (grid && cards.length) {
      let empty = document.getElementById('rv-colour-empty');
      if (!empty) {
        empty = document.createElement('div');
        empty.id = 'rv-colour-empty';
        empty.setAttribute('role', 'status');
        const text = document.createElement('p');
        text.textContent = root.dataset.rvEmptyColours;
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.textContent = root.dataset.rvClearColours;
        clear.addEventListener('click', () => { selected = []; writeUrl(); apply(); });
        empty.append(text, clear);
        grid.after(empty);
      }
      empty.hidden = count > 0;
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; apply(); });
  }
  root.querySelectorAll('button.rv-catalog__color[data-color]').forEach(button => {
    button.addEventListener('click', () => {
      const value = normalise(button.dataset.color);
      selected = selected.includes(value) ? selected.filter(colour => colour !== value) : [...selected, value];
      writeUrl();
      apply();
    });
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'rv_color') return;
    event.stopImmediatePropagation();
    selected = [...input.form.querySelectorAll('input[name="rv_color"]:checked')].map(input => normalise(input.value));
    writeUrl();
    apply();
  }, true);
  window.addEventListener('popstate', () => {
    selected = new URLSearchParams(location.search).getAll('rv_color').map(normalise);
    apply();
  });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('product-card,#ResultsList,#rv-filters') || node.querySelector('product-card,#rv-filters'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
